import { useTranslation } from "react-i18next";
import {
  MenuItem,
  Button,
  Stack,
  Collapse,
  Typography,
  Menu,
  Select as MuiSelect,
  Paper,
  ListItemIcon,
  ListItemText, SvgIcon, Chip, FormControlLabel, Switch,
  InputLabel
} from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { toast } from 'react-toastify';
import EstimationService from "../../services/estimations.service";
import ProjectTaskService from "../../services/projectTask.service";
import ProjectDetailUserCard from "./ProjectDetailUserCard";
import { TrueffortButton, TrueffortConfirmAlert, TrueffortTextField } from "../../MUIstyle/MUICustom";
import { Pending as PendingIcon, Delete as DeleteIcon, Edit as EditIcon, Close as CloseIcon, Save as SaveIcon } from '@mui/icons-material';
import AssignUsersDrawer from "../AssignUsersDrawer";
import { confirmAlert } from "react-confirm-alert";
import { addNWorkingDaysToADate, dateToDateLocale, formatSeconds, statusAllowedSinceStatus } from "../../util/GlobalFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import AddIcon from "@mui/icons-material/Add";
import { useAuthContext } from "../../contexts/AuthenticationContext";
import { ID_STATUS_CANCELED, ID_STATUS_COMPLETED, MIN_LEVEL_LEADER } from "../../util/Constants";
import { User } from "../../models/user";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import TrueffortChipStatus from "./TrueffortChipStatus";
import DatePicker from 'react-datepicker';
import { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { styleReactSelect } from "../../MUIstyle/GlobalStyles";
import { formatDateString } from "../../util/DateDataFormat";
import InteroperabilityService from "../../services/interoperabilty.service";

/*export type TaskType = {
  idProjectTask:number,
  name: string,
  duration: number,
  effort: number,
  registredDate: any
};*/

export enum UserStatus {
  Unassigned = 0,
  Assigned = 1,
  Saved = 3
}

// @ts-ignore
function ProjectDetailTaskRow({ element, phase, task, taskType, users, states, _fillProjectInfo, hidePhaseAndTask, project, tasks, priorityTypes, hasSecuency }) {
  //console.log(project);
  //console.log(states);
  console.log(task);
  //console.log(priorityTypes);
  //console.log(taskType);
  //console.log(users);
  const { t } = useTranslation();
  const { user } = useAuthContext() as { user: User };
  //console.log(taskType?.users);
  const [open, setOpen] = useState(hidePhaseAndTask);
  const [showModal, setShowModal] = useState(false);
  const [changeValuesOnAssignedUsers, setChangeValuesOnAssignedUsers] = useState(false);
  const [rankedUsers, setRankedUsers] = useState([]);
  const [notRankedUsers, setNotRankedUsers] = useState([]);
  const projectTaskService = useMemo(() => new ProjectTaskService(), []);
  const estimationService = useMemo(() => new EstimationService(), []);
  const [idSelectedStatus, setIdSelectedStatus] = useState(task.status_id);
  const [isEditing, setIsEditing] = useState(false);
  const [taskStatesAllowed, setTaskStatesAllowed] = useState([]);
  const [valuesUsersSelect, setValuesUsersSelect] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openOptions = Boolean(anchorEl);
  const interoperabilityService = useMemo(() => new InteroperabilityService(), []);
  const [usersTask, setUsersTask] = useState(0);
  const [usuariosAsignados, setUsuariosAsignados] = useState(task.users);
  const [selPriorityType, setSelPriorityType] = useState(() => {
    if (priorityTypes.length == 0 && task.priorities.length == 0) { return null; }
    if (task.priorities.length == 0) { return {value: priorityTypes[0].idPriorityType, label: priorityTypes[0].name}; }
    let prio = priorityTypes.find((prt:any) => prt.idPriorityType == task.priorities[0].priority_type_id);
    return {value: prio.idPriorityType, label: prio.name};
  });
  const [parents, setParents] = useState([]);
  const [listActivities, setListActivities]:any = useState([]);
  console.log(parents);
  useEffect(() => {
    //console.log('project');
    fillUsersRankedNotRanked();
  }, [project]);

  useEffect(() => {
    let list:any = [];
    project.elements.forEach((pe:any) => 
      pe.phases.forEach((pp:any) => pp.tasks.forEach((pt:any) => {if(pt.id != task.id) {
        list.push({...pt, fullName: pe.name + " - " + pp.type_name + " - " + pt.type_name});
      }})));
    setListActivities(list);
  }, [project]);

  useEffect(() => {
    if (task.priorities.length > 0) {
      setParents(listActivities.filter((act:any) => act.id == task.priorities[0].parent_task_id).map((pt:any) => ({
        value: pt.id,
        label: pt.fullName,
        data: pt
      })));
    }
  }, [listActivities]);

  useEffect(() => {
    //console.log(rankedUsers);
  }, [rankedUsers]);

  useEffect(() => {
    //console.log(notRankedUsers);
  }, [notRankedUsers]);

  const fillUsersRankedNotRanked = () => {
    let itemsRank = [];
    let ids = users.map((us: any) => us.idUser);
    if (taskType && Array.isArray(taskType?.users)) {
      itemsRank = taskType?.users.filter((us: any) => ids.includes(us.id)).map((user: any) => ({
        ...user,
        status: task.users.findIndex((usr: any) => usr.id === user.id) !== -1 ?
          UserStatus.Saved :
          UserStatus.Unassigned
      }));
    }
    setRankedUsers(itemsRank);

    const ttUsers = taskType && Array.isArray(taskType?.users) ? taskType?.users.map((user: any) => user.id) : [];
    let itemsNotRank = users.filter((user: any) => !ttUsers.includes(user.idUser)).map(
      (user: any) => ({
        id: user.idUser,
        name: user.name,
        lastname: user.lastName,
        email: user.email,
        effort_interp_avg: taskType ? taskType.effort_avg : 0,
        image_id: user.imageDto.idImage,
        image_url: user.imageDto.url,
        status: task.users.findIndex((usr: any) => usr.id === user.idUser) !== -1 ?
          UserStatus.Saved :
          UserStatus.Unassigned
      })
    );
    setNotRankedUsers(itemsNotRank);

    setUsersTask(task.users.map((user: any) => ({
      ...user,
      effort_interp_avg: user.effort_interp_avg || (taskType ? taskType.effort_avg : 0)
    })))
  }

  const handleClickOptions = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseOptions = () => {
    setAnchorEl(null);
  };

  const saveAssignedUsers = (assignedUsers: any) => {
    const usersProjectTask = {
      idProjectTask: task.id,
      updatedTaskEffort: 0,
      updatedTaskDuration: 0,
      users: assignedUsers.map((usr: any) => usr.id)
    };

    if (changeValuesOnAssignedUsers) {
      let usersWithData: number = (usersTask.length + assignedUsers.length) -
        usersTask.reduce(
          (acc: number, usr: any) => acc + (!usr.effort_interp_avg ? 1 : 0),
          assignedUsers.reduce(
            (acc2: number, assignedUsr: any) => acc2 + (!assignedUsr.effort_interp_avg ? 1 : 0),
            0
          )
        );

      usersProjectTask.updatedTaskEffort = !usersWithData ? task.effort : // might delete
        Math.ceil((usersTask.reduce((acc: number, usr: any) => acc + usr.effort_interp_avg, 0) +
          assignedUsers.reduce((acc: number, usr: any) => acc + usr.effort_interp_avg, 0)) / usersWithData);
      usersProjectTask.updatedTaskDuration = !usersWithData ? task.duration : // might delete
        Math.ceil((taskType.duration_avg * taskType.team_sz_avg) / (usersTask.length + assignedUsers.length));
    } else {
      usersProjectTask.updatedTaskEffort = task.effort;
      usersProjectTask.updatedTaskDuration = task.duration;
    }

    // @ts-ignore
    projectTaskService.assignUsers(task.id, usersProjectTask).then(({ data: response }) => {
      if (response.internalError != null && response.internalError && response.message != null) {
        toast.error(response.message);
      } else {
        toast.success(t("project_tasks_page.user_assigned"));
        _fillProjectInfo();
      }
    });
  }

  const deleteUser = (usr: any) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='react-confirm-alert-body custom-ui'>
            <h3 style={{ marginBottom: "1em" }}>
              {t("user_page.msg_delete_confirm2")} <span
                className="dark">{usr.name + " " + usr.lastname + "?"}</span>
            </h3>
            <div className="react-confirm-alert-button-group">
              <Button
                onClick={() => {
                  const userProjectTask = {
                    idUser: usr.id,
                    idProjectTask: task.id,
                    updatedTaskEffort: 0,
                    updatedTaskDuration: 0,
                  };

                  if (changeValuesOnAssignedUsers) {
                    const taskUsrs = usersTask.filter((u: any) => u.id !== usr.id);
                    let divisor: number = taskUsrs.length - /* might delete */
                      taskUsrs.reduce((acc: number, usr: any) => acc + (!usr.effort_interp_avg ? 1 : 0), 0);

                    userProjectTask.updatedTaskEffort = !divisor ? taskType.effort_avg :
                      Math.ceil(taskUsrs.reduce((acc: number, u: any) => acc + u.effort_interp_avg, 0) / divisor);
                    userProjectTask.updatedTaskDuration = !divisor ? taskType.duration_avg :
                      Math.ceil((taskType.duration_avg * taskType.team_sz_avg) / taskUsrs.length);
                  } else {
                    userProjectTask.updatedTaskEffort = task.effort;
                    userProjectTask.updatedTaskDuration = task.duration;
                  }

                  try {
                    // @ts-ignore
                    projectTaskService.removeUserFromTask(task.id, userProjectTask).then(({ data: response }) => {
                      toast.success(t("project_tasks_page.msg_success_delete_user"));
                      _fillProjectInfo();
                    }).catch(function (error: any) {
                      toast.error("Ocurrió un error al eliminar al usuario.");
                    });
                  } catch (error) {
                    console.log("Error #Users handleDelete" + JSON.stringify(error));
                    toast.error("Ocurrió un error al eliminar al usuario.");
                  }
                  onClose();
                }}>
                {t("project_page.msg_delete_task_confirm_yes")}
              </Button>
              <Button onClick={onClose}>{t("project_page.msg_delete_task_confirm_no")}</Button>
            </div>
          </div>
        );
      }
    });
  }

  const validate = (values: any) => {
    let errors: any = {};
    // No aplica para tareas terminadas
    if (task.status_id != 4) {
      if (values.duration < 0) {
        errors.duration = t("project_tasks_page.msg.errors.duration_negative");
      }
      if (values.effort < 0) {
        errors.effort = t("project_tasks_page.msg.errors.effort_negative");
      }
    }

    if (new Date(values.registredDate) < new Date(project.registred_date)) {
      errors.registredDate = t("project_tasks_page.msg.errors.registred_date");
    }

    return errors;
  }

  const handleSubmit = (values: any) => {
    let errors = validate(values);
    if (JSON.stringify(errors) != '{}') {
      setFormTask({ values: formTask.values, errors: errors });
      return;
    }
    setAnchorEl(null);
    let objPrio = {idPriorityType: selPriorityType?.value, parents: parents.map((par:any) => par.value)};
    let projectTaskAux = {
      name: '',
      status: {
        idStatus: idSelectedStatus
      },
      users: getArrUsersFromValues(),
      estimatedDays: values.duration,
      estimatedTime: values.effort,
      registredDate: values.registredDate,
      finishDate: [ID_STATUS_COMPLETED, ID_STATUS_CANCELED].includes(idSelectedStatus) ? dateToDateLocale(new Date()).toISOString() : null,
      estimatedStartDate: values.estimatedStartDate,
      estimatedFinishDate: values.estimatedFinishDate,
      priorities: hasSecuency ? [objPrio] : []
    }

    // @ts-ignore
    projectTaskService.update(task.id, projectTaskAux).then(({ data: response }) => {
      if (response.internalError != null && response.internalError && response.message != null) {
        toast.error(response.message);
        setIsEditing(false);
        _fillProjectInfo();
        const id = setInterval(() => {
          _fillProjectInfo();
        }, 60000);
        localStorage.setItem('idDetail', id+'');
      } else {
        toast.success(t("project_page.msg_success_task_update"));
        setIsEditing(false);
        // SE LLAMA AL SERVICIO PARA LLENAR LAS ESTIMACIONES CADA QUE SE CAMBIA EL STATUS A UNA TAREA
        // @ts-ignore
        estimationService.create().then(() => {
          _fillProjectInfo();
          const id = setInterval(() => {
            _fillProjectInfo();
          }, 60000);
          localStorage.setItem('idDetail', id+'');
        });
        interoperabilityService.reviewProjectElementStatus(element.id).then(() => {});
      }
      //fillProjectTasks();
    });
  }

  const prepareEdit = (t: any) => {
    setAnchorEl(null);
    setIsEditing(true);
    clearInterval(parseInt(localStorage.getItem('idDetail')+'') || 0);
    // Determinar los estados permitidos a partir del estado actual
    setTaskStatesAllowed(statusAllowedSinceStatus({ status_id: task.status_id, status_name: task.status_name }));
  }

  function getArrUsersFromValues() {
    let arr: { idProject: number; idUser: number; }[] = [];
    valuesUsersSelect.map((usr: any, k: number) => {
      arr.push({ idProject: 0, idUser: usr.value });
    });
    return arr;
  }

  const [formTask, setFormTask] = useState({
    values: {
      idProjectTask: 0, name: '', duration: task.duration,
      effort: task.effort, registredDate: dateToDateLocale(new Date(task.registred_date+"T12:00:00.000")),
      estimatedStartDate: dateToDateLocale(new Date(task.estimated_start_date+"T12:00:00.000")) , estimatedFinishDate: task.estimated_finish_date+"T12:00:00.000"
    }, errors: { duration: null, effort: null }
  });

  const deleteProjectTask = (task: any) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='react-confirm-alert-body custom-ui'>
            <h3 style={{ marginBottom: "1em" }}>{t("project_page.msg_delete_task_confirm2")} <span className="dark">{task.type_name + "?"}</span></h3>
            <p className="red"><strong>{t("project_page.msg_delete_task_confirm3")}</strong></p>
            <div className="react-confirm-alert-button-group">
              <Button
                onClick={() => {
                  setShowLoading(true);
                  try {
                    // @ts-ignore
                    projectTaskService.delete(task.id).then(({ data: response }) => {
                      toast.success(t("project_page.msg_success_task_delete"));
                      _fillProjectInfo();
                      setShowLoading(false);
                    }).catch(function (error: any) {
                      toast.error("Ocurrió un error al eliminar la tarea.");
                      setShowLoading(false);
                    });
                  } catch (error) {
                    console.log("Error #Users handleDelete" + JSON.stringify(error));
                    toast.error("Ocurrió un error al eliminar la tarea.");
                    setShowLoading(false);
                  }
                  onClose();
                }}>
                {t("project_page.msg_delete_task_confirm_yes")}
              </Button>
              <Button onClick={onClose}>{t("project_page.msg_delete_task_confirm_no")}</Button>
            </div>
          </div>
        );
      }
    });
  }

  const handleEstimatesChangeOnAssignedUsers = () => {
    if (!changeValuesOnAssignedUsers) { // Si se activa el recalculo de estimaciones
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <TrueffortConfirmAlert
              title={
                <Typography color='error' variant='h6' fontWeight={700} marginBottom='20px' >
                  <ReportProblemIcon color='error' />&nbsp;&nbsp;{t("Warning")}
                </Typography>
              }
              alertColor='error'
              messages={[
                t("project_page.msg_recalculate_estimates_1"),
                t("estimation_page.msg_recalculate_estimates_2")
              ]}
              buttons={[
                {
                  label: t("project_page.msg_delete_task_confirm_no"),
                  onClick: onClose
                },
                {
                  label: t("export_excel.yes"),
                  onClick: () => {
                    setChangeValuesOnAssignedUsers(!changeValuesOnAssignedUsers);
                    onClose();
                  }
                }
              ]}
            />
          );
        }
      });
    } else { // Si se desactiva el recalculo de estimaciones
      setChangeValuesOnAssignedUsers(!changeValuesOnAssignedUsers);
    }
  }

  const getNamesPriorities = (prio:any) => {
    let names = "";
    prio.forEach((pr:any) => {
      let objTask = tasks.find((ta:any) => ta.idTask == pr.parent_task_id);
      names += (objTask?.name || "") + "; "
    })
    return names;
  }

  useEffect(() => {
    if (parents.length > 0) {
      let dates = parents.map((par:any) => new Date(par.data.estimated_finish_date+"T12:00:00.000"));
      let maxDate = new Date(Math.max(...dates));
      let countDay = maxDate.getDay() == 5 ? 3 : maxDate.getDay() == 6 ? 2 : 1;
      maxDate.setDate(maxDate.getDate() + countDay);
      let estFinDdate = addNWorkingDaysToADate(maxDate, formTask?.values.duration);
      setFormTask({ values: { ...formTask.values, estimatedStartDate: dateToDateLocale(maxDate), 
        estimatedFinishDate: estFinDdate }, errors: formTask.errors })
    }
  }, [parents]);

  return (
    <>
      {!hidePhaseAndTask && !isEditing &&
        <Paper
          variant="outlined"
          square
          sx={{ paddingTop: '3px', backgroundColor: 'rgba(242, 233, 255, 0.30)' }}
        >
          <Grid container spacing={1} alignItems="center" sx={{ padding: 0 }} >
            <Grid item xs={5.99} style={{paddingLeft:'50px'}}>
              <Typography sx={{ fontSize: '0.75rem', fontWeight: '700' }} onClick={() => setOpen(!open)} className='project-detail-task-row' component='span' >
                {task.type_name}
              </Typography>
            </Grid>
            <Grid item xs={1.8} style={{padding:0, background:'#D7EBF0', minHeight:'32px', marginTop: '-1px'}}></Grid>
            <Grid item xs={1.8} style={{padding:0, background:'#CFF1AB', minHeight:'32px', marginTop: '-1px'}}></Grid>
            <Grid item xs={1.9} style={{padding:0, background:'#DFDFDF', minHeight:'32px', marginTop: '-1px'}}></Grid>
            <Grid item xs={0.47 } style={{padding:0, minHeight:'32px', marginTop: '-1px'}}></Grid>
            <Grid item xs={0.5} />
            <Grid item xs={1.49} sx={{ display: "flex", justifyContent: 'center' }} >
              <TrueffortChipStatus
                status_id={task.status_id}
                status_name={task.status_name}
              />
            </Grid>
            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {task?.registred_date === 0 ? '----------' : task?.registred_date}
              </Typography>
            </Grid>
            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {task.start_date === 0 ? '----------' : task.start_date}
              </Typography>
            </Grid>

            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {task.end_date === 0 ? '----------' : task.end_date}
              </Typography>
            </Grid>

            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {task.estimated_finish_date === 0 ? '----------' : task.estimated_finish_date}
              </Typography>
            </Grid>

            <Grid item xs={0.9} sx={{ background: '#D7EBF0', minHeight:'45px' }}
              style={{}}
            >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {task.duration.toLocaleString()}
              </Typography>
            </Grid>

            <Grid item xs={0.9} sx={{ background: '#D7EBF0', minHeight:'45px' }} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {formatSeconds(task.effort * 3600, false, false, false)}
              </Typography>
            </Grid>

            <Grid item xs={0.9} style={{background: '#CFF1AB', minHeight:'45px'}} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {task.registered_duration.toLocaleString()}
              </Typography>
            </Grid>

            <Grid item xs={0.9} style={{background: '#CFF1AB', minHeight:'45px' }}>
              <Typography align="center" sx={{ fontSize: '0.75rem', display:'flex', flexDirection:'column' }} >
                <span>{formatSeconds(task.registered_effort_hours * 3600 + task.registered_effort_minutes * 60, false, false, false)}</span>
                <span>{task.effort * 3600 == 0 ? "--" : ((task.registered_effort_hours * 3600 + task.registered_effort_minutes * 60) / (task.effort * 3600) * 100).toFixed(2) + '%'}</span>
              </Typography>
            </Grid>
            <Grid item xs={1} style={{background:'#DFDFDF', minHeight:'45px'}}>
              <Typography align="center" color={task.days_deviation < 0 ? "error" : "#5eba00"} sx={{ fontSize: '0.75rem', fontWeight:'bold' }} >
                {Math.abs(task.days_deviation)}
              </Typography>
            </Grid>

            <Grid item xs={0.9} style={{background:'#DFDFDF', minHeight:'45px'}}>
              <Typography align="center" color={(task.registered_effort_hours * 3600 + task.registered_effort_minutes * 60) == 0 ? '' : (task.registered_effort_hours * 3600 + task.registered_effort_minutes * 60) - (task.effort * 3600) > 0 ? "error" : "#5eba00"} sx={{ fontSize: '0.75rem', fontWeight:'bold' }} >
                {(task.registered_effort_hours * 3600 + task.registered_effort_minutes * 60) == 0 ? 0 : formatSeconds(Math.abs((task.registered_effort_hours * 3600 + task.registered_effort_minutes * 60) - (task.effort * 3600)), false, false, false)}
              </Typography>
            </Grid>

            <Grid item xs={0.47} sx={{ display: 'flex', justifyContent: 'center'}} >
              {user.role.accessLevel >= MIN_LEVEL_LEADER &&
                <Typography variant='subtitle2' color='#6693CB' align="center" 
                onClick={handleClickOptions} style={{cursor: 'pointer'}}
              >
                <PendingIcon fontSize="small" />
              </Typography>}

              <Menu
                id="basic-menu"
                sx={{
                  '& .MuiPaper-root': {
                    backgroundColor: '#050536'
                  }
                }}
                anchorEl={anchorEl}
                open={openOptions}
                onClose={handleCloseOptions}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <MenuItem onClick={() => prepareEdit(task)}>
                  <ListItemIcon>
                    <EditIcon size="small" sx={{ color: '#F5F5F5' }} />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#F5F5F5' }}>
                    {t("elements.buttons.edit")}
                  </ListItemText>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleCloseOptions();
                    deleteProjectTask(task);
                  }}
                >
                  <ListItemIcon>
                    <DeleteIcon size="small" sx={{ color: '#989898' }} />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#989898' }} >
                    {t("delete")}
                  </ListItemText>
                </MenuItem>
              </Menu>
            </Grid>
            {task.priorities?.length > 0 && <>
              <Grid item xs={5.99} style={{paddingLeft:'50px'}}>
                <Typography sx={{ fontSize: '0.75rem', fontWeight: '700' }} onClick={() => setOpen(!open)} className='project-detail-task-row' component='span' >
                  {"Prioridad: " + getNamesPriorities(task.priorities)}
                </Typography>
              </Grid>
              <Grid item xs={1.8} style={{padding:0, background:'#D7EBF0', minHeight:'32px', marginTop: '-1px'}}></Grid>
              <Grid item xs={1.8} style={{padding:0, background:'#CFF1AB', minHeight:'32px', marginTop: '-1px'}}></Grid>
              <Grid item xs={1.9} style={{padding:0, background:'#DFDFDF', minHeight:'32px', marginTop: '-1px'}}></Grid>
              </>
            }
          </Grid>
        </Paper>
      }
      {!hidePhaseAndTask && isEditing &&
        <Paper variant="outlined" square sx={{ padding: '10px', backgroundColor: '#DCDCDC' }} >
          <Grid container spacing={2} alignItems="center" >
            <Grid item xs={0.3} />
            <Grid item xs={11.7} >
              <Typography sx={{ fontSize: '0.75rem', fontWeight: '700' }} onClick={() => setOpen(!open)} component='span' >
                {task.type_name}
              </Typography>
            </Grid>
            <Grid item xs={0.2} />
            <Grid item xs={1.45} >
              <MuiSelect
                fullWidth
                id="idSlTaskStatus"
                size="small"
                name="idStatus"
                onChange={(e: any) => {
                  setIdSelectedStatus(e.target.value);
                  setFormTask({
                    values: { ...formTask.values, idSelectedStatus: e.target.value },
                    errors: formTask.errors
                  });
                }}
                value={idSelectedStatus}
              >
                {states?.map((ts: any, k: number) =>
                  <MenuItem
                    key={ts.idStatus}
                    disabled={typeof taskStatesAllowed.find((s: any) => s.idStatus == ts.idStatus) == "undefined"}
                    value={ts.idStatus}>
                    {ts.name}
                  </MenuItem>
                )}
              </MuiSelect>
            </Grid>
            <Grid item xs={1.45}>
              <DatePicker
                style={{ width: '100%' }}
                dateFormat="yyyy/MM/dd"
                selected={formTask?.values?.registredDate}
                onChange={(date: any) => setFormTask({ values: { ...formTask.values, registredDate: dateToDateLocale(date) }, errors: formTask.errors })}
                customInput={<TrueffortTextField
                  size="small"
                  name="registredDate"
                  inputProps={{ background: 'red' }}
                  error={formTask.errors.registredDate || ''}
                />}
              />
            </Grid>
            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {task.start_date === 0 ? '----------' : task.start_date}
              </Typography>
            </Grid>

            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {task.end_date === 0 ? '----------' : task.end_date}
              </Typography>
            </Grid>

            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {task.estimated_finish_date === 0 ? '----------' : task.estimated_finish_date}
              </Typography>
            </Grid>
            <Grid item xs={1} >
              <TrueffortTextField
                name="duration"
                type="number"
                min="0"
                size="small"
                variant="filled"
                maxLength={6} disabled={task.status_id == 4}
                onChange={(ev: any) => {
                  let estFinDdate = addNWorkingDaysToADate(formTask.values.estimatedStartDate, ev.target.value);
                  setFormTask({ values: { ...formTask.values, duration: ev.target.value, estimatedFinishDate: estFinDdate }, errors: formTask.errors })}
                }
                value={formTask.values.duration}
                error={formTask.errors?.duration || ''}
              />
            </Grid>

            <Grid item xs={1} >
              <TrueffortTextField
                name="effort"
                type="number"
                min="0"
                size="small"
                variant="filled"
                maxLength={6} disabled={task.status_id == 4}
                onChange={(ev: any) => setFormTask({ values: { ...formTask.values, effort: ev.target.value }, errors: formTask.errors })}
                value={formTask.values.effort}
                error={formTask.errors?.effort || ''}
              />
            </Grid>

            <Grid item xs={0.5} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {task.registered_duration.toLocaleString()}
              </Typography>
            </Grid>

            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem', display:'flex', flexDirection:'column' }} >
                <span>{formatSeconds(task.registered_effort_hours * 3600 + task.registered_effort_minutes * 60, false, false, false)}</span>
                <span>{task.effort * 3600 == 0 ? "--" : ((task.registered_effort_hours * 3600 + task.registered_effort_minutes * 60) / (task.effort * 3600) * 100).toFixed(2) + '%'}</span>
              </Typography>
            </Grid>
            <Grid item xs={0.9} >
              <Typography align="center" color={task.days_deviation < 0 ? "error" : "#5eba00"} sx={{ fontSize: '0.75rem', fontWeight:'bold' }} >
                {Math.abs(task.days_deviation)}
              </Typography>
            </Grid>
            <Grid item xs={0.9} >
              <Typography align="center" color={(task.registered_effort_hours * 3600 + task.registered_effort_minutes * 60) == 0 ? '' : (task.registered_effort_hours * 3600 + task.registered_effort_minutes * 60) - (task.effort * 3600) > 0 ? "error" : "#5eba00"} sx={{ fontSize: '0.75rem', fontWeight:'bold' }} >
                {(task.registered_effort_hours * 3600 + task.registered_effort_minutes * 60) == 0 ? 0 : formatSeconds(Math.abs((task.registered_effort_hours * 3600 + task.registered_effort_minutes * 60) - (task.effort * 3600)), false, false, false)}
              </Typography>
            </Grid>
            <Grid item xs={0.5} >
              <Stack direction='column' alignItems='center' >
                <TrueffortButton
                  style={{ maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px' }}
                  size="small"
                  color="secondary"
                  id="btnOptionsElement"
                  aria-controls={openOptions ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openOptions ? 'true' : undefined}
                  onClick={() => {
                    let d = dateToDateLocale(new Date());
                    setFormTask({
                      values: { idProjectTask: 0, duration: task.duration, effort: task.effort, registredDate: d, estimatedstartDate: d, estimatedFinishDate: d },
                      errors: { duration: null, effort: null }
                    });
                    setIsEditing(false);
                    const id = setInterval(() => {
                      _fillProjectInfo();
                    }, 60000);
                    localStorage.setItem('idDetail', id+'');
                  }}
                >
                  <CloseIcon />
                </TrueffortButton>

                <TrueffortButton
                  style={{ maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px' }}
                  size="small"
                  color="primary"
                  id="btnOptionsElement"
                  aria-controls={openOptions ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openOptions ? 'true' : undefined}
                  onClick={() => handleSubmit(formTask.values)}
                >
                  <SaveIcon />
                </TrueffortButton>
              </Stack>
            </Grid>
            {(isEditing && hasSecuency) ? 
              <Grid xs={12} container spacing={1} style={{paddingLeft:'1.3em'}}>
              <Grid item xs={4}>
                <InputLabel
                    sx={{
                        fontWeight: 700,
                        color: '#4A4A4A',
                        fontSize: '0.75rem'
                    }}
                >
                    {"Tipo de prioridad"}
                </InputLabel>
                <Select
                    name="idsPriorityTypes"
                    placeholder={"Tipos de prioridad"}
                    isDisabled={true}
                    value={selPriorityType}
                    onChange={(option: any) => setSelPriorityType(option)}
                    options={
                        priorityTypes.map((pt: any, k: number) => {
                            return ({
                                value: pt.idPriorityType,
                                label: pt.name
                            })
                        })
                    }
                    styles={styleReactSelect}
                >
                </Select>
              </Grid>
              <Grid item xs={8}>
                <InputLabel sx={{ fontWeight: 700, color: '#4A4A4A', fontSize: '0.75rem'}}
                > {"Actividad predecesora"}</InputLabel>
                <Select
                    name="idsActivities"
                    value={parents}
                    isMulti={false}
                    onChange={(option: any) => setParents([option])}
                    options={
                      listActivities.map((act: any, k: number) => {
                          return ({
                              value: act.id,
                              label: act.fullName,
                              data: act
                          })
                      })
                    }
                    styles={styleReactSelect}
                >
                </Select>
              </Grid>
              <Grid item xs={4}>
                <DatePicker
                  style={{width:'100%'}}
                  dateFormat="dd/MM/yyyy"
                  selected={formTask.values.estimatedStartDate}
                  onChange={(date:any) => {
                    let estFinDdate = addNWorkingDaysToADate(date, formTask?.values.duration);
                    setFormTask({ values: { ...formTask.values, estimatedStartDate: dateToDateLocale(date), estimatedFinishDate: estFinDdate }, errors: formTask.errors })
                  }}
                  customInput={<TrueffortTextField 
                    size="small" 
                    name="registredDate"
                    fullWidth
                    labelstring={"Fecha estimada de inicio"}
                  />}
                />
              </Grid>
              <Grid item xs={4}>
              <InputLabel
                    sx={{
                        fontWeight: 700,
                        color: '#4A4A4A',
                        fontSize: '0.75rem'
                    }}
                >
                    {"Fecha estimada de fin"}
                </InputLabel>
                {formatDateString(formTask.values.estimatedFinishDate, "dd/MM/yyyy", null, false)}
              </Grid>
              {/*props.task.projectTask.estimatedStartDate +" - " +props.task.projectTask.estimatedFinishDate*/}
            </Grid>
            : null}
            {formTask.errors.duration && <Grid item xs={12} style={{ color: 'red', fontSize: '0.75rem' }}>{formTask.errors.duration}</Grid>}
            {formTask.errors.effort && <Grid item xs={12} style={{ color: 'red', fontSize: '0.75rem' }}>{formTask.errors.effort}</Grid>}
            {formTask.errors.registredDate && <Grid item xs={12} style={{ color: 'red', fontSize: '0.75rem' }}>{formTask.errors.registredDate + ' ' + project.registred_date}</Grid>}
          </Grid>
        </Paper>
      }


      <Collapse in={open} timeout="auto" unmountOnExit>
        <Paper
          variant="outlined"
          square
          sx={{ padding: '10px', backgroundColor: 'rgba(242, 233, 255, 0.30)' }}
        >
          <Grid container spacing={1} >
            <Grid item xs={0.5} />

            <Grid item xs={2} sx={{ paddingLeft: "1rem" }}>
              <Stack spacing={1} direction="column">
                <Typography variant="subtitle2" >
                  <SvgIcon fontSize="small" >
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.75 2.75V5.5C2.75 5.86467 2.89487 6.21441 3.15273 6.47227C3.41059 6.73013 3.76033 6.875 4.125 6.875H8.70833M8.70833 6.875L6.875 5.04167M8.70833 6.875L6.875 8.70833" stroke="#553D74" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </SvgIcon>

                  {t("estimation_page.participants")}
                </Typography>
                <Chip
                  sx={{ borderRadius: '3px' }}
                  icon={<FontAwesomeIcon icon={faUsers} color={'#9A64E2'} />}
                  label={"Total: " + usersTask.length}
                  variant='outlined'
                />
                {user.role.accessLevel >= MIN_LEVEL_LEADER &&
                  <TrueffortButton
                    variant="outlined"
                    size="small"
                    color='secondary'
                    //disabled={!notRankedUsers.length && !rankedUsers.length}
                    startIcon={<AddIcon />}
                    onClick={() => setShowModal(true)}
                  >
                    {t("project_tasks_page.add_user")}
                  </TrueffortButton>
                }
                {/*<Box sx={{borderRadius: "0.1875rem", border: "solid 1px #DCDCDC", width: "fit-content", padding: "0.1rem"}} >
                                    <GroupsIcon fontSize="small" sx={{color: "#9A64E2", marginBottom: "-6px"}} /> {t("total")}: {usersTask.length}
                                </Box>*/}
              </Stack>
            </Grid>
            <Grid xs={7}>
              <Grid container spacing={1} padding={1}>
                {rankedUsers
                  .filter((usr: any) => usr.status === UserStatus.Saved)
                  .map((usr: any, i: number) =>
                    <Grid item key={'u'+i.toString()}>
                      <ProjectDetailUserCard
                        key={usr.name + "-" + usr.lastname}
                        userInfo={usr}
                        _deleteUser={deleteUser}
                        index={i}
                        detail={true}
                        pendingSave={false}
                      />
                    </Grid>
                  )
                }

                {notRankedUsers
                  .filter((usr: any) => usr.status === UserStatus.Saved)
                  .map((usr: any, i: number) =>
                    <Grid item key={'k'+i.toString()}>
                      <ProjectDetailUserCard
                        key={usr.name + "-" + usr.lastname}
                        userInfo={usr}
                        _deleteUser={deleteUser}
                        index={i}
                        detail={true}
                        pendingSave={false}
                      />
                    </Grid>
                  )
                }
              </Grid>
            </Grid>

            <Grid item xs >
              <FormControlLabel
                control={
                  <Switch
                    checked={changeValuesOnAssignedUsers}
                    onChange={handleEstimatesChangeOnAssignedUsers}
                  />
                }
                label={t("users_modal.recalculate_estimates")}
              />
            </Grid>
          </Grid>
        </Paper>
      </Collapse>

      <AssignUsersDrawer
        open={showModal}
        anchor='right'
        onClose={() => setShowModal(false)}
        users={{
          notRankedUsers: notRankedUsers,
          rankedUsers: rankedUsers.sort((usr1: any, usr2: any) => usr2.ranking - usr1.ranking)
        }}
        setUsers={{
          setNotRankedUsers: setNotRankedUsers,
          setRankedUsers: setRankedUsers
        }}
        taskName={taskType ? taskType.name : task.type_name}
        assignUsers={saveAssignedUsers}
        /*automaticEstimatesState={{
            changeValuesOnAssignedUsers: changeValuesOnAssignedUsers,
            handleEstimatesChangeOnAssignedUser: handleEstimatesChangeOnAssignedUser
        }}*/
        page='detail'
        usuariosAsignados={usuariosAsignados}
      //handleCheckboxChange={selectUser}
      />
    </>
  );
}

export default ProjectDetailTaskRow;